import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as ApexCharts from 'apexcharts';
import { APP_CONSTANTS } from 'src/app/constants/constants';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
	selector: 'app-stage-process-analysis',
	templateUrl: './stage-process-analysis.component.html',
	styleUrls: ['./stage-process-analysis.component.scss']
})
export class StageProcessAnalysisComponent implements OnInit {
	@Input() opp_type: any;
	@Input() stepper_stage: any;
	@Input() selected_opportunity_period: any;

	@Output() analysisChanged = new EventEmitter<any>();

	user_details: any;

	constructor(
		private storageService: StorageService,
		public commonService: CommonService,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");
		this.getAnalysisData();
	}

	abbreviateNumber(value) {
		let fixed = 1;
		let num = value;
		if (num === null) {
			return null;
		}
		if (num === 0) {
			return '0';
		}
		fixed = !fixed || fixed < 0 ? 0 : fixed;
		var b = num.toPrecision(2).split('e'),
		k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
		c =
		k < 1
		? num.toFixed(0 + fixed)
		: (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
		d = c < 0 ? c : Math.abs(c),
		e = d + ['', 'K', 'M', 'B', 'T'][k];
		return e;

		// value = Math.round(value);
		// let new_value = value;
		// if (value >= 1000) {
		//     const suffixes = ["", "K", "M", "B","T"];
		//     const suffixNum = Math.floor( (""+value).length/3 );
		//     let shortValue: any = '';
		//     for (var precision = 2; precision >= 1; precision--) {
		//         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
		//         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
		//         if (dotLessShortValue.length <= 2) { break; }
		//     }
		//     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
		//     new_value = shortValue+suffixes[suffixNum];
		// }
		// return new_value;
	}

	analysis_data: any;
	getAnalysisData() {
		let role: any = "";
			if (this.user_details.role.role == 4) {
				role = "Advisor Manager";
			} else if (this.user_details.role.role == 5) {
				role = "Advisor";
			} else if (this.user_details.role.role == 6) {
				role = "AFA";
			} else if (this.user_details.role.role == 8) {
				role = "Relationship Manager";
			} else if (this.user_details.role.role == 11) {
				role = "Marketing Team";
			}

			this.commonService.getData("/salesprocessanalysis/?role=" + role + "&opp_type=" + this.opp_type + "&stage=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order + "&opp_year=" + this.selected_opportunity_period).subscribe(
				(res: any) => {
					this.analysis_data = res;
					setTimeout(() => {
						this.createBreakdownChart();
						this.createRuleBasedBreakdownGraph();
						this.createAITrriggerBreakdownGraph();
					}, 200);
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
	}

	opp_breakdown_id: any = "";
	opp_breakdown_name: any = "";
	createBreakdownChart() {
		let $this = this;
		const options = {
			colors: $this.analysis_data["donout_graph"]["colors"],
			series: $this.analysis_data["donout_graph"]["data"],
			chart: {
				type: 'donut',
				events: {
					// mounted: function(chartContext, config) {
					// 	setTimeout(() => {
					// 		const svgNS = "http://www.w3.org/2000/svg";
					// 		const svgElement = chartContext.el.querySelector('.apexcharts-svg');
					// 		const rect = svgElement.getBoundingClientRect();

					// 		// Dynamically calculate the center based on the SVG dimensions
					// 		const centerX = rect.width / 2;
					// 		const centerY = rect.height / 2;

					// 		chartContext.w.config.series.forEach((value, i) => {
					// 			const angle = (i / chartContext.w.config.series.length) * 2 * Math.PI; // Simplified; for evenly spaced circles
					// 			const radius = Math.min(centerX, centerY) * 0.75; // 75% towards the edge of the SVG
					// 			const x = centerX + radius * Math.cos(angle);
					// 			const y = centerY + radius * Math.sin(angle);

					// 			// Create and append the circle
					// 			let circle = document.createElementNS(svgNS, "circle");
					// 			circle.setAttribute("cx", x.toString());
					// 			circle.setAttribute("cy", y.toString());
					// 			circle.setAttribute("r", "30"); // Circle radius
					// 			circle.setAttribute("fill", "white");
					// 			// circle.setAttribute("fill", $this.analysis_data["donout_graph"]["colors"][i]);
					// 			circle.setAttribute("stroke", "#D3D3D3");
					// 			// circle.setAttribute("stroke", "#FFFFFF");
					// 			circle.setAttribute("stroke-width", "1");
					// 			// circle.setAttribute("stroke-width", "2");
					// 			svgElement.appendChild(circle);

					// 			// Create and append the text, adjust as needed
					// 			let text = document.createElementNS(svgNS, "text");
					// 			text.setAttribute("x", x.toString());
					// 			text.setAttribute("y", (y + 5).toString()); // Slightly offset for text alignment
					// 			text.setAttribute("text-anchor", "middle");
					// 			text.setAttribute("alignment-baseline", "middle");
					// 			text.setAttribute("fill", "black");
					// 			text.textContent = $this.commonService.abbreviateNumber(value).toString();
					// 			svgElement.appendChild(text);
					// 		});
					// 	}, 100); // Delay to ensure chart is fully rendered
					// },
					dataPointSelection: function (event, chartContext, config) {
						const details = {
							id: $this.analysis_data["donout_graph"]['labels'][config.dataPointIndex],
							name: $this.analysis_data["donout_graph"]['labels'][config.dataPointIndex],
						};
						$this.opp_breakdown_id = details.id;
						$this.opp_breakdown_name = details.name;

						const data = {
							type: "Opportunities",
							id: details.id,
							name: details.name,
						};
						$this.analysisChanged.emit(data);
					},
				},
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 500,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
				},
			},
			plotOptions: {
				pie: {
					// startAngle: 180,
					// endAngle: -180,
					donut: {
						size: '65%',
						labels: {
							show: true,
							total: {
								show: true,
								showAlways: true,
								label: 'Total',
								fontSize: '16px',
								fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
								fontWeight: 400,
								color: '#000000',
								formatter: function (w) {
									// Calculate the total value
									const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
									// Custom label to display
									return `${(total.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT))}`;
								}
							}
						}
					}
				}
			},
			dataLabels: {
				enabled: true,
				style: {
					fontSize: '18px',
					fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
					fontWeight: 400,
				},
				formatter(val, opts) {
					const data = $this.commonService.abbreviateNumber(opts.w.globals.series[opts.seriesIndex])
					return [data]
				},
			},
			labels: $this.analysis_data["donout_graph"]["labels"],
			legend: {
				position: 'bottom',
				enabled: false,
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
			},
			tooltip: {
				y: {
					formatter: function (value) {
						// let val: string | number = Math.abs(value);
						// if (val >= 10 ** 3 && val < 10 ** 6) {
						// 	val = (val / 1000).toFixed(0) + 'K';
						// } else if (val >= 10 ** 6) {
						// 	val = (val / 1000000).toFixed(0) + 'M';
						// } else {
						// 	val = val;
						// }
						// return val;
						// return value.toLocaleString();
						return value.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
					},
				},
			},
		};
		var chart = new ApexCharts(document.querySelector("#breakdown-graph"), options);
		chart.render();
	}

	rules_breakdown_id: any =  "";
	rules_breakdown_name: any =  "";
	createRuleBasedBreakdownGraph() {
		let $this = this;
		var options = {
			colors: $this.analysis_data["rulebasedtree_graph"]["colors"],
			series: [
				{
					data: $this.analysis_data["rulebasedtree_graph"]["data"]
				}
		  	],plotOptions: {
        treemap: {
        dataLabels: {
          // Turn OFF autoscaling so your fontSize is respected
          format: 'truncate',
        }
        }
      },
			dataLabels: {
        enabled: true,
        style: {
          fontSize: '18px !important',
          fontWeight: '400 !important',
          colors: ['#000000'] // Specify your desired text color here
        },
      },
			legend: {
				show: false
			},
			chart: {
				height: 500,
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: true,
				},
				type: 'treemap',
				events: {
					dataPointSelection: function(event, chartContext, config) {
						const details = {
							id: $this.analysis_data["rulebasedtree_graph"]['data'][config.dataPointIndex]['id'],
							name: $this.analysis_data["rulebasedtree_graph"]['data'][config.dataPointIndex]['x'],
						};
						$this.rules_breakdown_id = details.id;
						$this.rules_breakdown_name = details.name;

						const data = {
							type: "Rule Based Triggers",
							id: details.id,
							name: details.name,
						};
						$this.analysisChanged.emit(data);

					}
				}
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
				},
			},
			title: {
				text: ''
			},
			tooltip: {
				// y: {
				//   formatter: function (val) {
				//     return val
				//   }
				// }
				custom: function ({ series, seriesIndex, dataPointIndex, w }) {
					return (
						'<div style="width:300px; padding:8px">' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name:</b> ' +
						$this.analysis_data["rulebasedtree_graph"]['data'][dataPointIndex]['x'] +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Count:</b> ' +
						$this.analysis_data["rulebasedtree_graph"]['data'][dataPointIndex]['y'].toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT) +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Condition:</b> ' +
						$this.analysis_data["rulebasedtree_graph"]['data'][dataPointIndex]['condition'] +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Description:</b> ' +
						$this.analysis_data["rulebasedtree_graph"]['data'][dataPointIndex]['description'] +
						'</p>' +
						'</div>'
					);
				},
				// fixed: {
				// 	enabled: true,
				// 	position: "topRight"
				// }
			},
		};

		var chart = new ApexCharts(document.querySelector("#rule-based-breakdown-graph"), options);
		chart.render();
	}

	ai_breakdown_id: any =  "";
	ai_breakdown_name: any =  "";
	createAITrriggerBreakdownGraph() {
		let $this = this;
		var options = {
			colors: $this.analysis_data["aibasedtree_graph"]["colors"],
			series: [
				{
					data: $this.analysis_data["aibasedtree_graph"]["data"]
				}
		  	],
        plotOptions: {
        treemap: {
        dataLabels: {
          // Turn OFF autoscaling so your fontSize is respected
          format: 'truncate',
        }
        }
      },
			dataLabels: {
        enabled: true,
        style: {
          fontSize: '18px !important',
          fontWeight: '400 !important',
          colors: ['#000000'] // Specify your desired text color here
        },
      },
			legend: {
				show: false
			},
			chart: {
				height: 500,
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				type: 'treemap',
				events: {
					dataPointSelection: function(event, chartContext, config) {
						const details = {
							id: $this.analysis_data["aibasedtree_graph"]['data'][config.dataPointIndex]['id'],
							name: $this.analysis_data["aibasedtree_graph"]['data'][config.dataPointIndex]['x'],
						};
						$this.ai_breakdown_id = details.id;
						$this.ai_breakdown_name = details.name;

						const data = {
							type: "AI Triggers",
							id: encodeURIComponent(details.id),
							name: details.name,
						};

						$this.analysisChanged.emit(data);

					}
				}
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
				},
			},
			title: {
				text: ''
			},
			tooltip: {
				// y: {
				//   formatter: function (val) {
				//     return val
				//   }
				// }
				custom: function ({ series, seriesIndex, dataPointIndex, w }) {
					return (
						'<div style="width:300px; padding:8px">' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name:</b> ' +
						$this.analysis_data["aibasedtree_graph"]['data'][dataPointIndex]['x'] +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Count:</b> ' +
						$this.analysis_data["aibasedtree_graph"]['data'][dataPointIndex]['y'].toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT) +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Description:</b> ' +
						$this.analysis_data["aibasedtree_graph"]['data'][dataPointIndex]['description'] +
						'</p>' +
						'</div>'
					);
				},
				// fixed: {
				// 	enabled: true,
				// 	position: "topRight"
				// }
			},
		};

		var chart = new ApexCharts(document.querySelector("#ai-triggers-breakdown-graph"), options);
		chart.render();
	}

	rule_based_tooltip_section: any = [
		{
			name: "Rules-Based Triggers have been developed in collaboration with financial advisors, wealth management experts, and industry thought leaders, drawing on the collective experience of these professionals over the past 30 to 40 years."
		},
		{
			name: "This knowledge encompasses how financial advisors and institutions have historically identified new opportunities, cross-selling potentials, and clients who may be at risk of departing. These triggers are adaptable and can be customized to align with the specific internal regulations of any organization."
		}
	];

	ai_based_tooltip_section: any = [
		{
			name: "AI triggers have been pinpointed through the analysis of three specific scenarios as outlined below:",
			sub_sections: [
				{
					name: "",
					value: "Shifts in customer habits, as well as market and geographical conditions, have been monitored over the last 3 to 5 years. This analysis has consistently revealed certain opportunities or risks."
				},
				{
					name: "",
					value: "The detection of certain anomalies that lack substantial data backing. AI will monitor these closely to determine which are likely to become more regular occurrences.The detection of certain anomalies that lack substantial data backing. AI will monitor these closely to determine which are likely to become more regular occurrences."
				},
				{
					name: "",
					value: "A series of potential opportunities and risks have been identified by AI. Although they are not frequently occurring at present, they are forecasted to happen in the future."
				},
			]
		},
	];

}
